import React from "react";
import { Link } from "react-router-dom";
import GraduateOwl from "../../assets/authLogo1.png";
import styles from "./styles.module.scss";

const currentYear = new Date().getFullYear();

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.footerTop}>
      <div className={styles.footerBrand}>
        <img src={GraduateOwl} alt="" width="114" height="140" />
        <div>
          <strong>Train GRC</strong>
          <span>Practical training for people who explain technology risk.</span>
        </div>
      </div>

      <nav className={styles.footerNav} aria-label="Footer navigation">
        <div>
          <h2>Learn</h2>
          <a href="https://academy.traingrc.com/p/home">Academy courses</a>
          <Link to="/glossary">Glossary</Link>
          <a href="https://sso.teachable.com/secure/1110292/identity/login/password">
            Academy login
          </a>
        </div>
        <div>
          <h2>Work with us</h2>
          <Link to="/solutions">Solutions</Link>
          <a href="https://calendly.com/traingrc/custom-training-services">
            Custom training
          </a>
          <a href="https://calendly.com/traingrc/initial-advisory-requests">
            Advisory services
          </a>
        </div>
        <div>
          <h2>Train GRC</h2>
          <Link to="/about-us">About us</Link>
          <a href="https://www.linkedin.com/company/traingrc/">LinkedIn</a>
        </div>
      </nav>
    </div>
    <div className={styles.footerBottom}>
      <span>© {currentYear} Train GRC. All rights reserved.</span>
      <span>Seize your expertise.</span>
    </div>
  </footer>
);

export default Footer;
